import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './components/layouts/MainLayout.jsx';
import ScrollToTop from './components/common/ScrollToTop.jsx';
import HomePage from './pages/HomePage.jsx';
import AboutPage from './pages/AboutPage.jsx';
import AwardsPage from './pages/AwardsPage.jsx';
import AwardeeDetailPage from './pages/AwardeeDetailPage.jsx';
import VideosPage from './pages/VideosPage.jsx';
import DHMWorksPage from './pages/DHMWorksPage.jsx';
import SupportUsPage from './pages/SupportUsPage.jsx';
import BlogPage from './pages/BlogPage.jsx';
import ContactPage from './pages/ContactPage.jsx';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/awards" element={<AwardsPage />} />
          <Route path="/awards/:id" element={<AwardeeDetailPage />} />
          <Route path="/videos" element={<VideosPage />} />
          <Route path="/dhm-works" element={<DHMWorksPage />} />
          <Route path="/support-us" element={<SupportUsPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
